import React from 'react';
import { ShoppingCart } from 'lucide-react';
const CHECKOUT_URL = 'https://pay.hotmart.com/X105213767J?checkoutMode=10';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (typeof (window as any).utmify === 'function') {
      ;
      (window as any).utmify('track', 'addToCart');
    }
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  };
  return <button onClick={handleClick} className={`group relative inline-flex items-center justify-center w-full px-6 py-3 font-heading text-base md:text-lg font-bold text-white transition-all duration-300 bg-orange-600 rounded-lg hover:bg-orange-500 hover:scale-105 hover:shadow-[0_0_30px_rgba(249,115,22,0.4)] focus:outline-none focus:ring-4 focus:ring-orange-500/50 overflow-hidden cursor-pointer ${className}`} data-id="element-169">
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:animate-[shine_1.5s_ease-in-out_infinite]" data-id="element-170" />
      <ShoppingCart className="w-5 h-5 mr-2 animate-bounce" data-id="element-171" />
      <span className="relative z-10 tracking-wide uppercase" data-id="element-172">{children}</span>
    </button>;
}